class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(event.target, this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target, event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: '#main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: '#cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: '#cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: '#main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: '#cart-drawer-gamification',
        section: 'cart-drawer-gamification',
        selector: '.shopify-section'
      }
    ];
  }

  updateQuantity(target, line, quantity, name) {
    this.enableLoading(line);
    let formData = { line: line, quantity: quantity };
    let reqURL = routes.cart_change_url;

    let currentLineElement = target.closest('.cart-item');
    if (currentLineElement.hasAttribute('data-bundle-id')) {
      reqURL = routes.cart_update_url;
      const bundleId = currentLineElement.getAttribute('data-bundle-id')
      formData = this.buildBundleQuanityForm(bundleId, quantity);
    }

    formData.sections = this.getSectionsToRender().map((section) => section.section),
    formData.sections_url = window.location.pathname;

    fetch(reqURL + '.js', {
          body: JSON.stringify(formData),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
      })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if(parsedState.status == 422){
          if (window.showToast) {
            window.showToast(parsedState.message, 5000);
          }
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.querySelectorAll(section.id);

          if(elementToReplace){
            elementToReplace.forEach((element) => {
              if(element.querySelector(section.selector)){
                element.querySelector(section.selector).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }else{
                element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
              }
            });
          }
          crossSellITemsListeners();
          let cartDrawer = document.querySelector('cart-drawer');
          if(cartDrawer)
            cartDrawer.handleCrossSellGrapping();
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        // TODO: this error log is removed because it does not work in the floating cart, it arrives late and the values don't get filled either. We added a toast instead.
        // document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  buildBundleQuanityForm(bundleId, quantity) {
    var cartItemsNewQtys = [];
    var cartItems = this.querySelectorAll('.cart-item');

    cartItems.forEach( function(item, i) {
      if (item.getAttribute('data-bundle-id') == bundleId) {
        cartItemsNewQtys.push(quantity);
      } else {
        var itemQty = item.querySelector('[name="updates[]"]').value;
        cartItemsNewQtys.push(parseInt(itemQty));
      }
    });
    return { updates: cartItemsNewQtys };
  }

  updateLiveRegions(line, itemCount) {
    // TODO: this error log is removed because it does not work in the floating cart, it arrives late and the values don't get filled either. We added a toast instead.
    // if (this.currentItemCount === itemCount) {
    //   document.getElementById(`Line-item-error-${line}`)
    //     .querySelector('.cart-item__error-text')
    //     .innerHTML = window.cartStrings.quantityError.replace(
    //       '[quantity]',
    //       document.getElementById(`Quantity-${line}`).value
    //     );
    // }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
